import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";

/**
 * Smart redirect component for the root path
 * Shows landing page for unauthenticated users
 */
const RootRedirect = () => {
  const { user, loading } = useAuth();

  // Wait for auth to initialize
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If authenticated, redirect to appropriate dashboard
  if (user) {
    switch (user.role) {
      case "STAFF":
        return <Navigate to="/staff/dashboard" replace />;
      case "SYSTEM_OWNER":
        return <Navigate to="/system" replace />;
      case "ORG_OWNER":
        return <Navigate to="/merchant" replace />;
      case "EMPLOYEE":
        return <Navigate to="/redeemer" replace />;
      case "AGENCY":
        return <Navigate to="/agency" replace />;
      case "REDEEMER":
        return <Navigate to="/redeemer" replace />;
      default:
        return <Navigate to="/merchant" replace />;
    }
  }

  // Not logged in - show landing page
  return <LandingPage />;
};

export default RootRedirect;